import request from '@/utils/request'
import { parseStrEmpty } from "@/utils/ruoyi";



export function searchUser (query) {
  return request({
    url: '/system/user/search',
    method: 'get',
    params: query
  })
}

export function refreshDataPermission() {
  return request({
    url: '/system/user/refreshDataPermission',
    method: 'get'
  })
}

export function searchNotAuth (query) {
  return request({
    url: '/system/user/searchNotAuth',
    method: 'get',
    params: query
  })
}

// 查询用户详细
export function getUser (userId) {
  return request({
    url: '/system/user/' + parseStrEmpty(userId),
    method: 'get'
  })
}

// 新增用户
export function addUser (data) {
  return request({
    url: '/system/user',
    method: 'post',
    data: data
  })
}

// 修改用户
export function updateUser (data) {
  return request({
    url: '/system/user',
    method: 'put',
    data: data
  })
}

// 删除用户
export function delUser (userId) {
  return request({
    url: '/system/user/' + userId,
    method: 'delete'
  })
}

// 用户密码重置
export function resetUserPwd (userId, password) {
  const data = {
    userId,
    password
  }
  return request({
    url: '/system/user/resetPwd',
    method: 'put',
    data: data
  })
}

// 用户状态修改
export function changeUserStatus (userId, status) {
  const data = {
    userId,
    status
  }
  return request({
    url: '/system/user/changeStatus',
    method: 'put',
    data: data
  })
}

// 查询用户个人信息
export function getUserProfile () {
  return request({
    url: '/system/user/profile',
    method: 'get'
  })
}

// 修改用户个人信息
export function updateUserProfile (data) {
  return request({
    url: '/system/user/profile',
    method: 'put',
    data: data
  })
}

// 用户密码重置
export function updateUserPwd (oldPassword, newPassword) {
  const data = {
    oldPassword,
    newPassword
  }
  return request({
    url: '/system/user/profile/updatePwd',
    method: 'put',
    params: data
  })
}

// 用户密码重置-登录页的
export function updateLoginUserPwd (oldPassword, newPassword, Authorization) {
  const data = {
    oldPassword,
    newPassword
  }
  return request({
    url: '/system/user/profile/updatePwd',
    method: 'put',
    headers: {
      Authorization,
      isToken: false // 去掉自动设置token
    },
    params: data
  })
}

// 用户头像上传
export function uploadAvatar (data) {
  return request({
    url: '/system/user/profile/avatar',
    method: 'post',
    data: data
  })
}

// 查询授权角色
export function getAuthRole (userId) {
  return request({
    url: '/system/user/authRole/' + userId,
    method: 'get'
  })
}

// 编辑授权角色
export function updateAuthRole (data) {
  return request({
    url: '/system/user/authRole',
    method: 'put',
    params: data
  })
}

// 查询部门下拉树结构
export function deptTreeSelect () {
  return request({
    url: '/system/user/deptTree',
    method: 'get'
  })
}

//查询校区树
export function getSchoolTree () {
  return request({
    url: 'system/user/schoolTree',
    method: 'get'
  })
}

//查询用户的数据权限
export function getDataPermission (id) {
  return request({
    url: `system/user/${id}/dataPermission`,
    method: 'get'
  })
}

//添加用户数据权限
export function setDataPermission (params) {
  return request({
    url: 'system/user/setDataPermission',
    method: 'put',
    data: params
  })

}
// 修改Main平台邮箱
export function updateMainEmail() {
    return new Promise(resolve => {
        setTimeout(() => {
            resolve({
                code: 200,
            })
        },1000)
    })
}

//刷新用户微信
export function exeRefreshWx (employeeNo) {
  return request({
    url: `/contract/wx/addUserContactBatchManual`,
    method: 'post',
    data: {
      userId: employeeNo
    }
  })
}
